export const BusinessType = [
  {
      id: 'BT1',
      name: 'Doanh nghiệp tư nhân'
  },
  {
      id: 'BT2',
      name: 'Công ty trách nhiệm hữu hạn'
  },
  {
      id: 'BT3',
      name: 'Công ty trách nhiệm hữu hạn một thành viên (TNHH 1 TV)'
  },
  {
      id: 'BT4',
      name: 'Công ty cổ phần'
  },
  {
      id: 'BT5',
      name: 'Công ty hợp danh'
  }
]

